


// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   CircularProgress,
//   Stack,
// } from "@mui/material";
// import PublicIcon from '@mui/icons-material/Public';
// import PersonIcon from '@mui/icons-material/Person';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// import GroupIcon from '@mui/icons-material/Group';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import ExploreIcon from '@mui/icons-material/Explore';
// import InterestsIcon from '@mui/icons-material/Interests';

// const DemographicTab = ({ accessToken }) => {
//   const [demographics, setDemographics] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (!accessToken) return;

//     const fetchInstagramData = async () => {
//       setLoading(true);
//       try {
//         const response = await fetch(
//           `https://graph.instagram.com/me?fields=id,username&access_token=${accessToken}`
//         );
//         const data = await response.json();

//         if (data?.username) {
//           const instagramUrl = `https://www.instagram.com/${data.username}`;

//           const apiResponse = await fetch("http://localhost:8000/influencer/add-link", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ instaUrl: instagramUrl }),
//           });

//           const apiData = await apiResponse.json();
//           if (apiData?.data) {
//             setDemographics(apiData.data);
//           } else {
//             setError("Failed to retrieve demographics.");
//           }
//         } else {
//           setError("Failed to retrieve Instagram data.");
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError("Failed to load Instagram data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInstagramData();
//   }, [accessToken]);

//   if (loading) return <CircularProgress />;
//   if (error) return <Typography color="error">{error}</Typography>;

//   return (
//     <Box sx={{ p: 2 }}>
//       <Typography variant="h5" gutterBottom fontWeight="bold">
//         User Demographics
//       </Typography>

//       {demographics ? (
//         <Box>
//           <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//             <PublicIcon />
//             <Typography><strong>Country:</strong> {demographics.country || "Not Available"}</Typography>
//           </Stack>

//           <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//             <PersonIcon />
//             <Typography><strong>Gender:</strong> {demographics.gender || "Not Available"}</Typography>
//           </Stack>

//           <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//             <CalendarTodayIcon />
//             <Typography><strong>Age:</strong> {demographics.age || "Not Available"}</Typography>
//           </Stack>

//           <Stack direction="row" spacing={1} alignItems="center" mb={3}>
//             <ThumbUpIcon />
//             <Typography><strong>Quality Score:</strong> {demographics.qualityScore}</Typography>
//           </Stack>

//           {/* Audience Gender & Age */}
//           <Typography variant="h6" mb={1}><GroupIcon fontSize="small" /> Audience Gender & Age</Typography>
//           <Box mb={3}>
//             <Typography><strong>Male:</strong> {demographics.membersGendersAges?.summary?.m || "N/A"}</Typography>
//             <Typography><strong>Female:</strong> {demographics.membersGendersAges?.summary?.f || "N/A"}</Typography>
//             <Typography><strong>Average Age:</strong> {demographics.membersGendersAges?.summary?.avgAges || "N/A"}</Typography>
//           </Box>

//           {/* Audience Location */}
//           <Typography variant="h6" mb={1}><LocationOnIcon fontSize="small" /> Audience Location</Typography>
//           <Box mb={3}>
//             <Typography><strong>Cities:</strong> {demographics.membersCities?.join(", ") || "Not Available"}</Typography>
//             <Typography><strong>Countries:</strong> {demographics.membersCountries?.join(", ") || "Not Available"}</Typography>
//           </Box>

//           {/* Additional Audience Reach Data */}
//           <Typography variant="h6" mb={1}><ExploreIcon fontSize="small" /> Additional Audience Reach</Typography>
//           <Box mb={3}>
//             <Typography><strong>Countries Reach:</strong> {demographics.countries?.join(", ") || "N/A"}</Typography>
//             <Typography><strong>Cities Reach:</strong> {demographics.cities?.join(", ") || "N/A"}</Typography>
//           </Box>

//           {/* Interests */}
//           <Typography variant="h6" mb={1}><InterestsIcon fontSize="small" /> Audience Interests</Typography>
//           <Box mb={3}>
//             <Typography><strong>Interests:</strong> {demographics.interests?.join(", ") || "Not Available"}</Typography>
//           </Box>
//         </Box>
//       ) : (
//         <Typography>No demographics available to display.</Typography>
//       )}
//     </Box>
//   );
// };

// export default DemographicTab;



import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import PublicIcon from '@mui/icons-material/Public';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import GroupIcon from '@mui/icons-material/Group';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ExploreIcon from '@mui/icons-material/Explore';
import InterestsIcon from '@mui/icons-material/Interests';

const DemographicTab = ({ instagramURL }) => {
  const [demographics, setDemographics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!instagramURL) return;

    const fetchDemographics = async () => {
      setLoading(true);
      try {
        const apiResponse = await fetch("https://server-side-influencer.onrender.com/influencer/add-link", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ instaUrl: instagramURL }),
        });

        const apiData = await apiResponse.json();
        if (apiData?.data) {
          setDemographics(apiData.data);
        } else {
          setError("Failed to retrieve demographics.");
        }
      } catch (err) {
        console.error("Error fetching demographics:", err);
        setError("Failed to load demographics.");
      } finally {
        setLoading(false);
      }
    };

    fetchDemographics();
  }, [instagramURL]);

  const renderSkeleton = () => (
    <div style={{ padding: "16px" }}>
      <h3><Skeleton width={200} height={30} /></h3>
      {[...Array(6)].map((_, i) => (
        <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }} key={i}>
          <Skeleton circle width={24} height={24} style={{ marginRight: "8px" }} />
          <Skeleton width={250} height={20} />
        </div>
      ))}
    </div>
  );

  if (loading) return renderSkeleton();
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div style={{ padding: "16px" }}>


      {demographics ? (
        <div>
          <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <PublicIcon style={{ marginRight: "8px" }} />
            <p><strong>Country:</strong> {demographics.country || "Not Available"}</p>
          </div>

          <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <PersonIcon style={{ marginRight: "8px" }} />
            <p><strong>Gender:</strong> {demographics.gender || "Not Available"}</p>
          </div>

          <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <CalendarTodayIcon style={{ marginRight: "8px" }} />
            <p><strong>Age:</strong> {demographics.age || "Not Available"}</p>
          </div>

          <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
            <ThumbUpIcon style={{ marginRight: "8px" }} />
            <p><strong>Quality Score:</strong> {demographics.qualityScore || "N/A"}</p>
          </div>

          <h4><GroupIcon fontSize="small" style={{ marginRight: "4px" }} /> Audience Gender & Age</h4>
          <div style={{ marginBottom: "16px" }}>
            <p><strong>Male:</strong> {demographics.membersGendersAges?.summary?.m || "N/A"}</p>
            <p><strong>Female:</strong> {demographics.membersGendersAges?.summary?.f || "N/A"}</p>
            <p><strong>Average Age:</strong> {demographics.membersGendersAges?.summary?.avgAges || "N/A"}</p>
          </div>

          <h4  className="mb-5"><LocationOnIcon fontSize="small" style={{ marginRight: "4px" }} /> Audience Location</h4>
          <div  style={{ marginBottom: "16px" }}>
            <p><strong>Cities:</strong> {demographics.membersCities?.map(city => city.name).join(", ") || "Not Available"}</p>
            <p style={{ marginTop: "8px" }}><strong>Countries:</strong> {demographics.membersCountries?.map(c => c.name).join(", ") || "Not Available"}</p>
          </div>

          <h4><ExploreIcon fontSize="small" style={{ marginRight: "4px" }} /> Additional Audience Reach</h4>
          <div style={{ marginBottom: "16px" }}>
            <p className="mt-3"><strong>Countries Reach:</strong> {demographics.countries?.map(c => c.name).join(", ") || "N/A"}</p>
            <p style={{ marginTop: "8px" }}><strong>Cities Reach:</strong> {demographics.cities?.map(c => c.name).join(", ") || "N/A"}</p>
          </div>

          <h4><InterestsIcon fontSize="small" style={{ marginRight: "4px" }} /> Audience Interests</h4>
          <div style={{ marginBottom: "16px" }}>
            <p><strong>Interests:</strong> {demographics.interests?.map(i => i.name || i).join(", ") || "Not Available"}</p>
          </div>
        </div>
      ) : (
        <p>No demographics available to display.</p>
      )}
    </div>
  );
};

export default DemographicTab;
